import { Footer } from "@/components/common/Footer";
import { Header } from "@/components/common/Navigation";
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface MainLayoutProps {
  children: ReactNode;
}

function MainLayout({ children }: MainLayoutProps) {
  const location = useLocation();
  const hideNavigation = ["/signup"].includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col ">
      {!hideNavigation && <Header />}
      <main
        className={
          hideNavigation
            ? "flex-1"
            : "flex-1"
        }
      >
        {children}
      </main>
      {!hideNavigation && <Footer />}
    </div>
  );
}

export default MainLayout;
